import { useQuery } from "@redux-requests/react";
import React from "react";
import { useIntl } from "react-intl";
import { Loader } from "../../components";
import {
  CheckboxField,
  FileUploaderField,
  MultipleSelectField,
  TextField
} from "../../components/formik";
import { types } from "../../ducks";
import useUserMe from "../../hooks/useUserMe";

const EposterForm = () => {
  const intl = useIntl();
  const { user } = useUserMe();
  const {
    data: { data: profiles },
    loading: profilesLoading
  } = useQuery({ type: types.GET_PROFILES, defaultData: { data: [] } });

  const {
    data: { data: tags },
    loading: tagsLoading
  } = useQuery({ type: types.GET_TAGS, defaultData: { data: [] } });

  const profileOptions = profiles.map(({ id, firstName, lastName }) => ({
    label: `${firstName} ${lastName}`,
    value: id
  }));

  const tagOptions = tags.map(({ name }) => ({
    label: name,
    value: name
  }));
  const disabledByRole = user.roles.includes("accademic");
  return (
    <>
      <FileUploaderField
        name="document"
        accept="application/pdf"
        label={intl.formatMessage({
          id: "Eposters.NewEposterDialog.EPosterPDFFile",
          defaultMessage: "E-Poster PDF file"
        })}
        buttonLabel={intl.formatMessage({
          id: "Eposters.NewEposterDialog.Upload",
          defaultMessage: "Upload"
        })}
      />
      <CheckboxField
        name="allowDownload"
        color="primary"
        label={intl.formatMessage({
          id: "Eposters.NewEposterDialog.AllowDownload",
          defaultMessage: "Allow Download"
        })}
        fullWidth
      />
      <TextField
        name="title"
        variant="outlined"
        label={intl.formatMessage({
          id: "Eposters.NewEposterDialog.Title",
          defaultMessage: "Title"
        })}
        disabled={disabledByRole}
        fullWidth
      />
      <TextField
        name="subTitle"
        variant="outlined"
        label={intl.formatMessage({
          id: "Eposters.NewEposterDialog.SubTitle",
          defaultMessage: "Sub title"
        })}
        disabled={disabledByRole}
        fullWidth
      />
      <TextField
        name="description"
        variant="outlined"
        label={intl.formatMessage({
          id: "Eposters.NewEposterDialog.Description",
          defaultMessage: "Description"
        })}
        fullWidth
        multiline
        rows={3}
      />
      <Loader loading={profilesLoading && tagsLoading}>
        <MultipleSelectField
          name="authors"
          label={intl.formatMessage({
            id: "Eposters.NewEposterDialog.Authors",
            defaultMessage: "Authors"
          })}
          disabled={disabledByRole}
          options={profileOptions}
        />
        <MultipleSelectField
          name="coAuthors"
          label={intl.formatMessage({
            id: "Eposters.NewEposterDialog.CoAuthors",
            defaultMessage: "Co-Authors"
          })}
          disabled={disabledByRole}
          options={profileOptions}
        />
        <MultipleSelectField
          name="tags"
          label={intl.formatMessage({
            id: "Eposters.NewEposterDialog.Tags",
            defaultMessage: "Tags"
          })}
          disabled={disabledByRole}
          options={tagOptions}
        />
        <TextField
          name="videoUrl1"
          variant="outlined"
          label={intl.formatMessage({
            id: "Eposters.NewEposterDialog.VideoUrl1",
            defaultMessage: "Video url #1"
          })}
          disabled={disabledByRole}
          fullWidth
        />
        <TextField
          name="videoUrl2"
          variant="outlined"
          label={intl.formatMessage({
            id: "Eposters.NewEposterDialog.VideoUrl2",
            defaultMessage: "Video url #2"
          })}
          disabled={disabledByRole}
          fullWidth
        />
        <TextField
          name="videoUrl3"
          variant="outlined"
          label={intl.formatMessage({
            id: "Eposters.NewEposterDialog.VideoUrl3",
            defaultMessage: "Video url #3"
          })}
          disabled={disabledByRole}
          fullWidth
        />
      </Loader>
    </>
  );
};

export default EposterForm;
